// src/components/TrustBadges.jsx
import React from 'react'
import { motion } from 'framer-motion'
import { 
  Shield, 
  Lock, 
  Award, 
  Check,
  Users,
  Clock,
  Globe,
  BadgeCheck
} from 'lucide-react'

const TrustBadges = () => {
  const badges = [
    {
      icon: Shield,
      text: "Bank-Level Security",
      description: "256-bit SSL encryption",
      color: "emerald"
    },
    {
      icon: Lock,
      text: "2FA Protected",
      description: "Multi-factor authentication",
      color: "blue"
    },
    {
      icon: Award,
      text: "Licensed Platform",
      description: "Fully regulated & compliant",
      color: "purple"
    },
    {
      icon: BadgeCheck,
      text: "Verified Company",
      description: "Transparent operations",
      color: "orange"
    },
    {
      icon: Users,
      text: "15K+ Investors",
      description: "Trusted community",
      color: "indigo"
    },
    {
      icon: Clock,
      text: "24/7 Support",
      description: "Always available",
      color: "red"
    }
  ]

  const colorClasses = {
    emerald: 'text-emerald-400',
    blue: 'text-blue-400',
    purple: 'text-purple-400',
    orange: 'text-orange-400',
    indigo: 'text-indigo-400',
    red: 'text-red-400'
  }

  return (
    <div className="flex flex-col sm:flex-row flex-wrap items-center justify-center gap-6 pt-4">
      {badges.map((badge, index) => (
        <motion.div
          key={badge.text}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1 }}
          className="flex items-center gap-3 group"
        >
          <div className="relative">
            <badge.icon className={`w-6 h-6 ${colorClasses[badge.color]} group-hover:scale-110 transition-transform`} />
            <div className="absolute inset-0 bg-white/20 rounded-full scale-0 group-hover:scale-100 transition-transform"></div>
          </div>
          <div className="text-left">
            <div className="text-sm font-medium text-blue-100 group-hover:text-white transition-colors">
              {badge.text}
            </div>
            <div className="text-xs text-blue-200/80">
              {badge.description}
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  )
}

export default TrustBadges